<template>
  <div>
    <b-modal
      id="confirmRemoveDayWithExtraInfo"
      modal-class="modal-cover"
      v-model="isVisible"
      hide-backdrop
      hide-footer
      content-class="shadow-lg modal-lg"
      centered
    >
      <section class="text-center">
        <b-row>
          <b-col cols="12" class="py-4">
            <h3 class="font-weight-bold title-text">
              ⚠️ {{ t('confirmRemoveDayWithExtraInfoTitle') }}
            </h3>
          </b-col>

          <b-col cols="12" class="py-3">
            <p class="message-text">
              {{ t('confirmRemoveDayWithExtraInfoBody') }}
              <br><br>
              <strong>{{ t('confirmRemoveDayIrreversible') }}</strong>
              <br><br>
              {{ t('confirmRemoveDaySureQuestion') }}
            </p>
          </b-col>

          <b-col cols="12" class="py-4">
            <b-btn
              pill
              variant="danger"
              class="action-button mb-3"
              @click="proceedToRemovalOptions"
            >{{ t('confirmRemoveDayRiskConfirm') }}</b-btn>

            <b-btn
              pill
              variant="secondary"
              class="action-button"
              @click="closePopup"
            >{{ t('cancel') }}</b-btn>
          </b-col>
        </b-row>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from '@/mixins/translationMixin';

export default {
  mixins: [translationMixin],
  props: ["value"],
  computed: {
    ...mapGetters(["inerModalParameters"]),
    isVisible: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    ...mapActions([
      "showModal",
      "showModalWithParameters",
    ]),
    proceedToRemovalOptions() {
      // Close this modal and show the existing day removal options modal
      this.showModalWithParameters({
        inerModalParameters: this.inerModalParameters,
        type: "areYouShureRemovingDay",
      });
    },
    closePopup() {
      this.showModal("");
    },
  },
};
</script>

<style scoped>
.modal.modal-cover .modal-content,
.modal.modal-cover .modal-footer,
.modal.modal-cover .modal-header {
  border: none;
}

.title-text {
  font-size: 24px;
  color: #D32F2F;
  margin-bottom: 20px;
}

.message-text {
  font-size: 18px;
  color: #2E2E3A;
  line-height: 1.6;
  margin: 0 auto;
  max-width: 85%;
}

.action-button {
  font-size: 18px;
  padding: 15px 30px;
  width: 80%;
  max-width: 500px;
  display: block;
  margin: 0 auto;
}

.action-button:hover {
  transform: translateY(-2px);
  transition: transform 0.2s ease;
}

.modal-lg {
  max-width: 600px;
}
</style> 